/** O que uma página "em breve" mostra, em texto (ver `core/page`). */
export function comingSoonDescription(title: string, description: string): string {
  return `Página "${title}" — ${description} Ainda não está disponível (em breve), não há dados nela.`;
}
